import React, {useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Logo from '../assets/std_emblem.png';
import SignOut from '../assets/Sign_Out.png';
import Demographics from '../assets/demographics.png';
import FirstMentionAwareness from '../assets/1st_mention_awareness.png';
import TotalAwareness from '../assets/Total_Awareness.png';
import CurrentBankUsage from '../assets/Current_Bank_Usage.png';
import MainBankUsageMarketShare from '../assets/Main_Bank_Usage_Market_Share.png';
import ProductMarketShare from '../assets/Product_Market_Share.png';
import BankConsideration from '../assets/Bank_Consideration.png';
import BankPreference from '../assets/Bank_Preference.png';
import ProductPreference from '../assets/Product_Preference.png';
import ImageryPerceptions from '../assets/Imagery_Perceptions.png';
import ChannelInteraction from '../assets/Channel_Interaction.png';
import authService from '../services/authService';

const Home = () => {
 
  const navigate = useNavigate();


  useEffect(() => {
   const user = authService.getCurrentUser();
   if (!user) {
     navigate('/login'); 
   }
 }, [navigate]);

  const handleLogout = async () => {
   const token = localStorage.getItem('token');

   if (!token) {
     navigate('/');
     return;
   }

   try {
     await axios.post('https://outlook.plus94research.co.za/api/logout/', null, {
       headers: {
         Authorization: `Token ${token}`,
       },
     });
     localStorage.removeItem('authToken'); 
     navigate('/');  
   } catch (error) {
     console.error('Error logging out:', error);
   }
};


  return (
    <div className='home'>

        <div className='home-top-bar'>
            <div className='home-logo'>
                <img src={Logo} alt="Standard Bank Logo"/>
            </div>
            <div className='home-top-bar-heading'>
                <h3>REGIONAL OUTLOOK | RESULTS</h3>
            </div>
            <div>
               <button className='sign-out' onClick={handleLogout}>
                  <img src={SignOut} alt="Sign Out"/>
               </button>
            </div>
        </div>

        <div className='components'>      


            <h2>CLICK ON ANY CATEGORY TO VIEW RESULTS</h2>  

             {/* Demographics Category */}

            <div className='demographics category'>
                <Link to="/demographics">
                   <img src={Demographics} alt="Demographics Logo"/>
                </Link>                
            </div>   

             {/* Awareness Category */}

             <div className='awareness category'>
                <Link to="/first-mention-awareness">
                   <img src={FirstMentionAwareness} alt="First Mention Awareness Logo"/>
                </Link>   
                <Link to="/total-awareness">
                   <img src={TotalAwareness} alt="Total Awareness Logo"/>
                </Link>              
            </div>

            {/* Usage Category */}

            <div className='usage category'>
                <Link to="/current-bank-usage">
                   <img src={CurrentBankUsage} alt="Current Bank Usage Logo"/>
                </Link>
                <Link to="/main-bank-usage-market-share">
                   <img src={MainBankUsageMarketShare} alt="Main Bank Usage Market Share Logo"/>
                </Link>
                <Link to="/product-market-share">
                   <img src={ProductMarketShare} alt="Product Market Share Logo"/>
                </Link>
                <Link to="/bank-consideration">
                   <img src={BankConsideration} alt="Bank Consideration Logo"/>
                </Link>     
                <Link to="/bank-preference">
                   <img src={BankPreference} alt="Bank Preference Logo"/>
                </Link>    
                <Link to="/product-preference">
                   <img src={ProductPreference} alt="Product Preference Logo"/>
                </Link> 
            </div>

            {/* Imagery Perceptions Category */}

            <div className='imagery-perceptions category'>
                <Link to="/imagery-perceptions">
                   <img src={ImageryPerceptions} alt="Imagery Perceptions Logo"/>
                </Link>
            </div>

             {/* Channel Interaction Category */}

             <div className='channel-interaction category'>
                <Link to="/channel-interaction">
                   <img src={ChannelInteraction}
                    alt="Channel Interaction Logo"
                    style={{ width: '180px', height: 'auto', margin: '10px' }} 
                    />
                </Link>
            </div>

        </div>
    </div>
  );
};

export default Home;

